<script setup lang="ts">
import InsurancePlaneCard from '@/components/ui/insurance/insurancePlaneCard.vue'
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'

const emit = defineEmits<{
	(e: 'scroll-to-top', theme: string): void
}>()

const props = defineProps<{
	pageContent: PageContent
	theme: 'shopping' | 'shipping'
}>()

const { pageContent } = props

const handleScrollToTop = (theme: string) => {
	emit('scroll-to-top', theme)
}
</script>

<template>
	<InsurancePlaneCard
		:page-content="pageContent"
		:theme="props.theme"
		@scroll-to-top="handleScrollToTop"
	/>
</template>
